import LanguageManager from './LanguageManager';

export default class CookieConsent {
   static instance = null;
   static REDIRECT_FLAG_KEY = 'languageRedirectDone';
   static FACEBOOK_SCRIPT_ID = 'facebook-jssdk';
   static FACEBOOK_APP_ID = '558865320408038';
   static LOCAL_STORAGE_KEY = 'consentMode';
   static REDIRECT_MAX_COUNT = 2; // 新しい定数

   // 定数
   static LOCAL_STORAGE_KEY = 'consentMode';

   static ERROR_MESSAGES = {
      INVALID_CONSENT: '無効な同意データです。',
      SAVE_FAILED: '同意情報の保存に失敗しました:',
      FB_LOAD_FAILED: 'Failed to load Facebook SDK script.',
      FB_INIT_FAILED: 'Facebook SDK could not be initialized.',
   };

   static getInstance() {
      if (!CookieConsent.instance) {
         CookieConsent.instance = new CookieConsent();
      }
      return CookieConsent.instance;
   }

   constructor() {
      if (CookieConsent.instance) {
         return CookieConsent.instance; // 既に存在するインスタンスを返す
      }
      this.languageManager = new LanguageManager('[data-cookie-consent="language-select"]');
      this.bannerSelector = '[data-cookie-consent="banner"]';
      this.modalSelector = '[data-cookie-consent="modal"]';
      this.acceptButtonSelector = '[data-cookie-consent="accept"]';
      this.declineButtonSelector = '[data-cookie-consent="decline"]';
      this.saveButtonSelector = '[data-cookie-consent="save"]';
      this.closeButtonSelector = '[data-cookie-consent="close"]';
      this.textJaSelector = '[data-cookie-consent="ui-text-ja"]';
      this.textEnSelector = '[data-cookie-consent="ui-text-en"]';
      this.facebookSDKLoaded = false;

      this.defaultConsent = {
         analytics_storage: 'denied',
         ad_storage: 'denied',
         ad_personalization: 'denied',
         ad_user_data: 'denied',
         functionality_storage: 'denied',
         social_media_storage: 'denied',
      };

      this.storedConsent = null; // 同意情報を保持するプロパティ

      // リダイレクト制御用のセッションストレージフラグ
      this.redirectFlag = sessionStorage.getItem(CookieConsent.REDIRECT_FLAG_KEY);

      this.init();

      CookieConsent.instance = this;
   }

   init() {
      // 言語設定の初期化を最初に行う（必須機能として）
      const preferredLanguage = this.languageManager.getLocalStorageLanguage() || this.languageManager.getBrowserLanguage();
      console.log('preferredLanguage', preferredLanguage);

      // 言語設定UIと自動リダイレクトを有効化
      this.languageManager.init();
      this.handleInitialLanguageRedirect(preferredLanguage);

      // UIのテキスト表示を切り替え
      const isJapanese = preferredLanguage === 'ja';
      this.toggleTextVisibility(isJapanese);

      // Cookie同意関連の初期化
      this.bindUIActions();
      this.checkStoredConsent();
   }

   toggleTextVisibility(isJapanese) {
      const textJa = document.querySelectorAll(this.textJaSelector);
      const textEn = document.querySelectorAll(this.textEnSelector);
      textJa.forEach(el => el.classList.toggle('hidden', !isJapanese));
      textEn.forEach(el => el.classList.toggle('hidden', isJapanese));
   }

   bindUIActions() {
      const acceptButtons = document.querySelectorAll(this.acceptButtonSelector);
      const declineButtons = document.querySelectorAll(this.declineButtonSelector);
      const saveButtons = document.querySelectorAll(this.saveButtonSelector);
      const closeButtons = document.querySelectorAll(this.closeButtonSelector);

      if (acceptButtons.length > 0) {
         acceptButtons.forEach((acceptButton) => {
            acceptButton.addEventListener('click', () => this.handleAccept());
         });
      }
      if (declineButtons.length > 0) {
         declineButtons.forEach((declineButton) => {
            declineButton.addEventListener("click", () => this.toggleModal(true));
         });
      }
      if (saveButtons.length > 0) {
         saveButtons.forEach((saveButton) => {
            saveButton.addEventListener('click', () => this.handleSave());
         });
      }
      if (closeButtons.length > 0) {
         closeButtons.forEach((closeButton) =>{
            closeButton.addEventListener('click', () => this.toggleModal(false));
         });
      }
   }

   checkStoredConsent() {
      const storedConsent = localStorage.getItem(CookieConsent.LOCAL_STORAGE_KEY);
      console.log('Stored consent:', storedConsent);

      if (!storedConsent) {
         this.toggleBanner(true);
         return;
      }

      try {
         const parsed = JSON.parse(storedConsent);
         console.log('Parsed consent:', parsed);

         if (!parsed.expiry || typeof parsed.expiry !== 'number' || new Date().getTime() >= parsed.expiry) {
            throw new Error('Invalid or expired consent.');
         }

         this.storedConsent = parsed;
         this.setConsent(parsed.value);
         this.toggleBanner(false);
      } catch (error) {
         console.error('Consent data invalid:', error);
         this.toggleBanner(true);
      }
   }

   toggleBanner(visible) {
      const banner = document.querySelector(this.bannerSelector);
      if (banner) banner.style.display = visible ? 'block' : 'none';
   }

   toggleModal(visible) {
      const modal = document.querySelector(this.modalSelector);
      if (modal) modal.style.display = visible ? 'flex' : 'none';
   }

   handleAccept() {
      this.setConsent({
         analytics_storage: 'granted',
         ad_storage: 'granted',
         ad_personalization: 'granted',
         ad_user_data: 'granted',
         functionality_storage: 'granted',
         social_media_storage: 'granted',
      });
      this.toggleBanner(false);
      console.log('Accepted all cookies.', );
   }

   handleSave() {
      const form = document.querySelector('[data-cookie-consent="settings-form"]');
      const consent = {
         analytics_storage: form.analytics_storage.checked ? 'granted' : 'denied',
         ad_storage: form.ad_storage.checked ? 'granted' : 'denied',
         ad_personalization: form.ad_personalization.checked ? 'granted' : 'denied',
         ad_user_data: form.ad_user_data.checked ? 'granted' : 'denied',
         functionality_storage: form.functionality_storage.checked ? 'granted' : 'denied',
         social_media_storage: form.social_media_storage.checked ? 'granted' : 'denied',
      };

      this.setConsent(consent);
      this.toggleModal(false);
      this.toggleBanner(false);
   }

   setConsent(consent) {
      const sixMonths = 6 * 30 * 24 * 60 * 60 * 1000;
      const expiry = new Date().getTime() + sixMonths;

      if (!consent) {
         console.error(CookieConsent.ERROR_MESSAGES.INVALID_CONSENT);
         return;
      }

      try {
         localStorage.setItem(CookieConsent.LOCAL_STORAGE_KEY, JSON.stringify({ value: consent, expiry }));
         console.log("同意情報を保存しました。");

         // リダイレクトフラグのリセット（言語設定は常に有効なため）
         sessionStorage.removeItem(CookieConsent.REDIRECT_FLAG_KEY);
         sessionStorage.removeItem('redirectCount');

         // GTag の更新
         if (typeof gtag !== 'undefined') {
            gtag('consent', 'update', consent);
         } else {
            console.log('GTag が利用できません。');
         }

         // ソーシャルメディアストレージの設定
         consent.social_media_storage === 'granted' ? this.initFacebookSDK() : this.disableFacebookSDK();
      } catch (error) {
         console.error(CookieConsent.ERROR_MESSAGES.SAVE_FAILED, error);
      }
   }

   initFacebookSDK() {
      if (this.facebookSDKLoaded) return;
      this.facebookSDKLoaded = true;

      const fbScriptId = CookieConsent.FACEBOOK_SCRIPT_ID;

      if (!document.getElementById(fbScriptId)) {
         const script = document.createElement('script');
         script.id = fbScriptId;
         script.src = 'https://connect.facebook.net/en_US/sdk.js';
         script.onload = () => this.initializeFacebookSDK();
         script.onerror = () => console.error(CookieConsent.ERROR_MESSAGES.FB_LOAD_FAILED);
         document.head.appendChild(script);
      }
   }


   // Facebook SDK の初期化
   // see @ https://developers.facebook.com/docs/javascript/quickstart?locale=ja_JP
   initializeFacebookSDK() {
      window.fbAsyncInit = () => {
         if (typeof FB !== 'undefined') {
            FB.init({
               appId: CookieConsent.FACEBOOK_APP_ID,
               autoLogAppEvents: true,
               xfbml: true,
               version: 'v21.0',
            });
            console.log('Facebook SDK initialized');
         } else {
            console.error(CookieConsent.ERROR_MESSAGES.FB_INIT_FAILED);
         }
      };
   }

   disableFacebookSDK() {
      console.log('Disabling Facebook SDK');
      try {
         const fbScript = document.getElementById(CookieConsent.FACEBOOK_SCRIPT_ID);
         if (fbScript) fbScript.remove();
         window.FB = undefined; // 完全削除より安全
      } catch (error) {
         console.error('Failed to disable Facebook SDK:', error);
      }
   }

   handleInitialLanguageRedirect(preferredLanguage) {
      if (this.shouldSkipRedirect()) {
         return;
      }

      const { shouldRedirect, newPath } = this.getRedirectPath(preferredLanguage);

      if (shouldRedirect) {
         this.executeRedirect(newPath);
      } else {
         this.setRedirectFlag();
      }
   }

   shouldSkipRedirect() {
      if (this.redirectFlag === 'done') {
         return true;
      }

      const currentUrl = new URL(window.location.href);
      if (currentUrl.searchParams.has('lang')) {
         this.setRedirectFlag();
         return true;
      }

      return false;
   }

   getRedirectPath(preferredLanguage) {
      const currentUrl = new URL(window.location.href);
      const isEnglishPath = currentUrl.pathname.startsWith('/en');
      let shouldRedirect = false;
      let newPath = currentUrl.pathname;

      if (preferredLanguage === 'en' && !isEnglishPath) {
         newPath = `/en${currentUrl.pathname}`;
         shouldRedirect = true;
      } else if (preferredLanguage === 'ja' && isEnglishPath) {
         newPath = currentUrl.pathname.replace(/^\/en(\/|$)/, '/');
         shouldRedirect = true;
      }

      return { shouldRedirect, newPath };
   }

   executeRedirect(newPath) {
      const redirectCount = parseInt(sessionStorage.getItem('redirectCount') || '0');
      if (redirectCount > CookieConsent.REDIRECT_MAX_COUNT) {
         console.warn('リダイレクトの最大回数に達しました');
         this.setRedirectFlag();
         return;
      }

      sessionStorage.setItem('redirectCount', (redirectCount + 1).toString());
      this.setRedirectFlag();

      const currentUrl = new URL(window.location.href);
      currentUrl.pathname = newPath;
      window.location.replace(currentUrl.href);
   }

   setRedirectFlag() {
      sessionStorage.setItem(CookieConsent.REDIRECT_FLAG_KEY, 'done');
   }
}
